/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DailyChallengeMenu',['pixi',
	'absolute',
	'absolute/stringmanager',
	'lodash',
	'MenuUI/MenuTab',
	'gameconfig',
	'MenuUI/Menu',
	'MenuUI/ChallengeTile',
	'Solitaire/SolitaireGameMode',
	'Solitaire/Solitaire',
	'MenuUI/GameEndDialog',
	'MenuUI/MsftButton',
	'MenuUI/DailyChallengeCalendar',
	'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService',
	'MenuUI/ColorConstants',
	'MenuUI/DailyChallengeProgressMeter',
	'MenuUI/DealWarningModal',
	'MenuUI/BadgeEarnedDialog',
	'util/SettingsManager',
	'MenuUI/ControlFocusManager',
	'audiosprites',
	'Managers/ScaleManager'
],

	function (PIXI, Absolute, _s, _, MenuTab, GameConfig, Menu, ChallengeTile, SolitaireGameMode, SolitaireGame, GameEndDialog,
		MsftButton, DailyChallengeCalendar, SolitaireDailyChallengeService, ColorConstants, DailyChallengeProgressMeter,
		DealWarningModal, FUEDialog, SettingsManager, ControlFocusManager, AudioData, ScaleManager) {

		var DailyChallengeMenu = function (ui, game) {
			this.initDailyChallengeMenu(ui, game);
		};

		DailyChallengeMenu.prototype = Object.create(Absolute.Screen.prototype);
		DailyChallengeMenu.prototype.constructor = DailyChallengeMenu;

		DailyChallengeMenu.prototype.initDailyChallengeMenu = function (ui, game) {
			Absolute.Screen.call(this);
			this.ui = ui;
			this.game = game;

			this.manualConfig = {
				navigationBarHeight: this.game.menuBar.y + this.game.menuBar.menuButton.height,

				page: 'The page that all content resides within.',
				pageWidth: 1920,
				pagePadding: 70,
				pageMenuSpacing: 40,

				menusShadowSize: 20, // Dont change, used for calcuations

				challengesMenu: 'The menu that has each challenge tile within.',
				challengesMenuPadding: 20,
				challengesMenuTabHeight: 80,
				challengesMenuTabWidth: 600,

				challengeTile: 'The tile that when selected takes you to the game challenge for that day.',
				challengeTileHeight: 475,
				challengeTileWidth: 0, // Auto scales with menu.
				challengeTileTilesCount: 5, // Auto updates when the day's challenges are recieved.
				challengeTileTilesPerRow: 1,
				challengeTileSpacingBetween: 20,

				calendarMenu: 'The menu that has the calendar showing selectable days to view challenges for that day.',
				calendarMenuMinimumHeight: 580,

				progressMenu: 'The menu that displays current progress of badge completion.',
				progressMenuHeight: 300,
				progressMenuScale: 1,


				heightOffset: 0,
				widthOffset: 0
			}
			this.menuContainer = new PIXI.DisplayObjectContainer();
			this.container = new PIXI.DisplayObjectContainer();
			this.firstRun = true;
			this.calculateConfigValues();

			this.dataInitialized = false;
			this.artInitialized = false;

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background.addChild(background);

			this.date = new Date();
			this.originalDate = new Date();
			this.months = _s('months', null, true);
			this.settingsManager = SettingsManager;

			this.controlsGroupMap = {};
			this.controlFocusManager = new ControlFocusManager();
			this.clickHandler = this.handleGameInput.bind(this);
			window.addEventListener('click', this.clickHandler);
			ScaleManager.addElement(this, { scaleChangeSource: 'Full' });
		};

		DailyChallengeMenu.prototype.updateMenuTextures = function () {
			this.completeInit();
		}

		DailyChallengeMenu.prototype.calculateConfigValues = function () {
			this.resizeUpdateTextures = false;

			// WARNING: Who ever is working on this in the future the screen scaling within 'handleResize()'
			// does not work properly I haven't found a fix so im using 'this.manualConfig.heightOffset' to
			// manually adjust the scaling for each screen size. This really should be fixed for longevity 
			// but I've spent too long trying to figure it out I'm just going use this hack for now.

			if (Absolute.Platform.isMobile()) {
				if (Absolute.ScreenMetrics.isPortrait()) {
					if (this.manualConfig.challengeTileTilesPerRow !== 3) {
						this.manualConfig.challengeTileTilesPerRow = 3;
						this.manualConfig.challengesMenuTabHeight = 120;
						this.manualConfig.challengesMenuTabWidth = 600;
						this.manualConfig.progressMenuScale = 1.75;
						this.manualConfig.heightOffset = -320; // This is a fix to a real problem with this components scale not adjusting for height properly
						this.resizeUpdateTextures = true;
					}
				} else {
					if (this.manualConfig.challengeTileTilesPerRow !== 5) {
						this.manualConfig.challengeTileTilesPerRow = 5;
						this.manualConfig.challengesMenuTabHeight = 80;
						this.manualConfig.challengesMenuTabWidth = 400;
						this.manualConfig.progressMenuScale = 1.25;
						this.manualConfig.heightOffset = -160;
						this.resizeUpdateTextures = true;
					}
				}
			} else if (ScaleManager.width < 1000) {
				if (this.manualConfig.challengeTileTilesPerRow !== 3) {
					this.manualConfig.challengeTileTilesPerRow = 3;
					this.manualConfig.challengesMenuTabHeight = 120;
					this.manualConfig.challengesMenuTabWidth = 500;
					this.manualConfig.progressMenuScale = 1.75;
					this.manualConfig.heightOffset = -320;
					this.resizeUpdateTextures = true;
				}
			} else {
				if (this.manualConfig.challengeTileTilesPerRow !== 5) {
					this.manualConfig.challengeTileTilesPerRow = 5;
					this.manualConfig.challengesMenuTabHeight = 80;
					this.manualConfig.challengesMenuTabWidth = 400;
					this.manualConfig.progressMenuScale = 1;
					this.manualConfig.heightOffset = -200;
					this.resizeUpdateTextures = true;
				}
			}

			const tileRowCount = Math.ceil(this.manualConfig.challengeTileTilesCount / this.manualConfig.challengeTileTilesPerRow);

			const challengesMenuHeight =
				(2 * this.manualConfig.challengesMenuPadding) +
				(tileRowCount) * (this.manualConfig.challengeTileSpacingBetween + this.manualConfig.challengeTileHeight)
				- this.manualConfig.challengeTileSpacingBetween + // For last row not having space inbetween
				tileRowCount * 5; // Fix because the height isn't scaling correctly

			const calendarMenuHeight = challengesMenuHeight > this.manualConfig.calendarMenuMinimumHeight ?
				challengesMenuHeight : this.manualConfig.calendarMenuMinimumHeight;

			const menusWidth =
				this.manualConfig.pageWidth +
				2 * this.manualConfig.menusShadowSize -
				2 * this.manualConfig.pagePadding +
				this.manualConfig.widthOffset;

			const menusHeight =
				this.manualConfig.progressMenuHeight +
				this.manualConfig.navigationBarHeight +
				this.manualConfig.challengesMenuTabHeight +
				((challengesMenuHeight > calendarMenuHeight) ? // Chooses taller menu.
					challengesMenuHeight : calendarMenuHeight) +
				this.manualConfig.pageMenuSpacing +
				2 * this.manualConfig.menusShadowSize +
				this.manualConfig.heightOffset;

			this.calculatedConfig = {
				challengesMenuHeight: challengesMenuHeight,

				challengeTileWidth:
					(menusWidth - this.manualConfig.menusShadowSize - (2 * this.manualConfig.challengesMenuPadding) -
						(this.manualConfig.challengeTileTilesPerRow - 1) * this.manualConfig.challengeTileSpacingBetween
					) / this.manualConfig.challengeTileTilesPerRow,

				calendarMenuHeight: calendarMenuHeight,

				menusWidth: menusWidth,
				menusHeight: menusHeight,

				pageWidth: this.manualConfig.pageWidth, // No change
				pageHeight: menusHeight + 2 * this.manualConfig.pagePadding
			}

			this.config = {}
			_.extend(this.config, this.manualConfig);
			_.extend(this.config, this.calculatedConfig);


			if (this.resizeUpdateTextures === true && this.firstRun === false) {
				this.updateMenuTextures();
			}
		}

		DailyChallengeMenu.prototype.handleResize = function () {
			this.calculateConfigValues();

			if (!this.container) return;

			this.menuContainer.width = this.config.menusWidth *
				(ScaleManager.height / this.config.pageHeight) *
				(this.config.pageWidth / ScaleManager.width)
				* ((this.game.ui.height - this.game.menuBar.menuButton.height - this.game.menuBar.y - (100)) / this.config.menusHeight);

			this.menuContainer.height =
				(this.config.menusHeight / this.config.pageHeight) *
				(this.config.menusWidth / this.config.pageWidth) *
				(this.game.ui.height - this.game.menuBar.menuButton.height - this.game.menuBar.y + (0));

			this.setMenuContainerPosition();


			if (this.menuContainer.x <= (this.config.pagePadding)) {
				this.menuContainer.height = this.config.menusHeight *
					(ScaleManager.width / this.config.pageWidth) *
					(this.config.pageHeight / ScaleManager.height)
					* ((this.game.ui.width - this.game.menuBar.menuButton.width - (0)) / this.config.menusWidth);

				this.menuContainer.width =
					(this.config.menusWidth / this.config.pageWidth) *
					(this.config.menusHeight / this.config.pageHeight) *
					(this.game.ui.width - this.game.menuBar.menuButton.width + (300));
			}

			this.setMenuContainerPosition();

			if (this.calendar) {
				this.calendar.y = Absolute.Coords.y(95);
				this.calendar.x = Absolute.Coords.x(901) - this.calendar.width / 2;
			}
            this.background.scale.set(
				1 / Math.min(ScaleManager.scaleFactorX, 1), 1 / Math.min(1, ScaleManager.scaleFactorY)
			);
		};

		DailyChallengeMenu.prototype.buildTileTextures = function () {

			function buildTileTexture(bgColor, iconId, textureId, config) {
				var icon = PIXI.Sprite.fromFrame(iconId),
					graphics = new PIXI.Graphics(),
					container = new PIXI.DisplayObjectContainer();

				graphics.beginFill(bgColor);
				graphics.drawRect(0, 0,
					Absolute.Coords.x(config.challengeTileWidth),
					Absolute.Coords.y(config.challengeTileHeight));
				graphics.endFill();

				container.addChild(graphics);

				icon.x = (container.width - icon.width) / 2;
				icon.y = (container.height - icon.height) / 2;

				container.addChild(icon);

				PIXI.Texture.addTextureToCache(container.generateTexture(), textureId);
			}

			buildTileTexture(ColorConstants.Klondike, "game_mode_tile_icons/icon_tile_klondike.png", "dailychallenge/DC_tile_klondike.png", this.config);
			buildTileTexture(ColorConstants.Spider, "game_mode_tile_icons/icon_tile_spider.png", "dailychallenge/DC_tile_spider.png", this.config);
			buildTileTexture(ColorConstants.FreeCell, "game_mode_tile_icons/icon_tile_freecell.png", "dailychallenge/DC_tile_freecell.png", this.config);
			buildTileTexture(ColorConstants.Pyramid, "game_mode_tile_icons/icon_tile_pyramid.png", "dailychallenge/DC_tile_pyramid.png", this.config);
			buildTileTexture(ColorConstants.TriPeaks, "game_mode_tile_icons/icon_tile_tripeaks.png", "dailychallenge/DC_tile_tripeaks.png", this.config);
		};

		DailyChallengeMenu.prototype.loadArtAssets = function (onSuccess, onError) {
			var levelLoader = new Absolute.Loader(),
				atlases = [{ name: 'dc_menu' }];
			var soundsToLoad = [];
			_.forEach(AudioData, function (clipInfo) {
				if (clipInfo.loadgroup === "challenge") {
					if (!Absolute.AudioManager.soundLoaded(clipInfo.id)) {
						clipInfo.lazyload = false;
						soundsToLoad.push(clipInfo);
					}
				}
			});

			levelLoader.loadSound(soundsToLoad, function (percentComplete) {
			},
				function () {

				});

			levelLoader.loadAtlases(atlases,
				function (percentComplete) {
					// todo show card spinner
					Absolute.Debug.log('loading dc menu assets ', percentComplete);
				}.bind(this),
				onSuccess,
				onError);
		};

		DailyChallengeMenu.prototype.onShow = function () {
			this.ui.showLoadingScreen();

			var now = new Date();

			if (this.originalDate.getMonth() !== now.getMonth()) {
				this.originalDate = now;
				this.date = now;
				this.dataInitialized = false;
				this.firstRun = true;
			}
			if (!this.dataInitialized) {
				SolitaireDailyChallengeService.Initialize(
					function () {
						this.dataInitialized = true;

						if (!this.artInitialized) {
							this.loadArtAssets(
								function () {
									this.artInitialized = true;
									this.completeInit();
								}.bind(this),
								this.showError.bind(this)
							);
						} else {
							this.completeInit();
						}
					}.bind(this),
					this.showLoadError.bind(this)
				);
			} else {
				if (!this.artInitialized) {
					this.loadArtAssets(
						function () {
							this.artInitialized = true;
							this.completeInit();
						}.bind(this),
						this.showError.bind(this)
					);
				} else {
					this.completeInit();
				}
			}
			this.handleResize()
		};

		DailyChallengeMenu.prototype.onHide = function () {
			if (this.progressMeter) {
				this.progressMeter.onHide();
			}
			if (this.lobbyMenu) {
				this.lobbyMenu.onHide();
			}
			this.resetControlManager();
			this.controlFocusManager.removeAllControls();
		};

		DailyChallengeMenu.prototype.completeInit = function () {
			var now = new Date();
			if (this.firstRun || this.resizeUpdateTextures) {

				if (this.menuContainer && this.menuContainer.children.length > 1) this.menuContainer.removeChildren(0, this.menuContainer.children.length-1);
				if (this.container && this.container.children.length > 1) this.container.removeChildren(0, this.container.children.length-1);

				if (!this.menuContainer) { this.menuContainer = new PIXI.DisplayObjectContainer(); }
				if (!this.container) { this.container = new PIXI.DisplayObjectContainer(); }

				this.buildTileTextures();
				this.buildTabs();
				this.buildProgressMeter();
				this.container.addChild(this.tabsContainer);
				this.container.addChild(this.progressMeter);
				this.menuContainer.addChild(this.container);
				if (
					SolitaireDailyChallengeService.dataNotExists &&
					this.settingsManager.getSetting('general', 'showDCFUE')
				) {
					SolitaireDailyChallengeService.dataNotExists = false;
					this.buildFUE();
					this.settingsManager.setSetting('general', 'showDCFUE', false);
				}
				if (
					!SolitaireDailyChallengeService.dataNotExists &&
					this.settingsManager.getSetting('general', 'showDCFUE')
				) {
					this.settingsManager.setSetting('general', 'showDCFUE', false);
				}
			}

			if (this.originalDate.getDate() < now.getDate()) {
				this.progressMeter.onDateChange(this.months[now.getMonth()]);
			}

			if (this.lobbyMenu) {
				this.lobbyMenu.onShow();
			}

			if (!this.resizeUpdateTextures) {
				this.addChild(this.game.menuBar);
				this.addChild(this.menuContainer);
				this.game.menuBar.onShow(true, true, false, Absolute.StringManager('titles.dailyChallenges'));
			}

			if (this.progressMeter) {
				this.progressMeter.onShow(this.firstRun || this.resizeUpdateTextures);
			}

			if (this.firstRun) {
				this.firstRun = false;
			}

			this.initControls();

			this.ui.hideLoadingScreen();

			this.updateTheme();

			this.menuContainer.height = this.game.ui.height - this.game.menuBar.menuButton.height - this.game.menuBar.y;
			this.menuContainer.width = this.config.menusWidth;

			this.setMenuContainerPosition();
			if (!this.resizeUpdateTextures) { this.handleResize(); }
			this.resizeUpdateTextures = false;
		};

		DailyChallengeMenu.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
			this.controlsGroupMap['ProgressMeter'] = this.progressMeter.getControls();
			this.controlsGroupMap['BottomButtons'] = [this.progressMeter.awardsButton];
			var keys = ['LeftButtons', 'RightButtons', 'Tabs', 'Calendar', 'ChallengeTiles', 'ProgressMeter', 'BottomButtons'];
			for (var i = 0; i < keys.length; i++) {
				if (this.controlsGroupMap.hasOwnProperty(keys[i])) {
					for (var j = 0; j < this.controlsGroupMap[keys[i]].length; j++) {
						this.controlFocusManager.addControl(this.controlsGroupMap[keys[i]][j], false, keys[i]);
					}
				}
			}
		};

		DailyChallengeMenu.prototype.updateTheme = function () {
			var theme, settingsTheme;
			theme = settingsTheme = SettingsManager.getSetting('theme', 'selected');
			this.challengeTiles.forEach(function (c) {
				c.challenge.theme = theme;
			});
		};

		DailyChallengeMenu.prototype.buildTabs = function () {
			var label = this.months[this.date.getMonth()] + ' ' + this.date.getDate();

			if (Absolute.StringManager.getUserLanguage() === "fr-CA" || Absolute.StringManager.getUserLanguage() === "fr-FR") {
				label = this.date.getDate() + ' ' + this.months[this.date.getMonth()].toLowerCase();
			}
			var menuTabsData = [
				{
					id: 'lobby',
					label: label,
					labelIcon: 'dailychallenge/tabicon_day.png',
					labelIconScale: this.config.challengesMenuTabHeight / 80,
					content: this.buildLobby(this.date),
					color: 0x1d7773,
					borderColor: 0x4c9e9a,
					tabWidth: Absolute.Coords.x(this.config.challengesMenuTabWidth),
					tabPosition: Absolute.Coords.x(this.config.challengesMenuPadding),
					tabHeight: Absolute.Coords.y(this.config.challengesMenuTabHeight - this.config.challengesMenuTabHeight / 5),
					tabHeightSelected: Absolute.Coords.y(this.config.challengesMenuTabHeight),
					height: Absolute.Coords.y(this.config.challengesMenuHeight),
					width: Absolute.Coords.x(this.config.menusWidth),
					selected: true,
					hoverBorderColor: 0x77adac,
					letterStyle: {
						font: Absolute.ScreenMetrics.getResScale() * this.config.challengesMenuTabHeight / 2 + 'px Arial',
						fontFamily: 'segoe',
						fill: '#a1d3c1',
						tint: 0xa1d3c1,
						align: 'left'
					}
				},
				{
					id: 'calendar',
					label: _s("DailyChallenge.calendar"),
					labelIcon: 'dailychallenge/tabicon_calendar.png',
					labelIconScale: this.config.challengesMenuTabHeight / 80,
					content: this.buildCalendar(),
					color: 0x2b598f,
					borderColor: 0x489fce,
					tabWidth: Absolute.Coords.x(this.config.challengesMenuTabWidth),
					tabPosition: Absolute.Coords.x(this.config.challengesMenuPadding + this.config.challengesMenuTabWidth),
					tabHeight: Absolute.Coords.y(this.config.challengesMenuTabHeight - this.config.challengesMenuTabHeight / 5),
					tabHeightSelected: Absolute.Coords.y(this.config.challengesMenuTabHeight),
					height: Absolute.Coords.y(this.config.calendarMenuHeight),
					width: Absolute.Coords.x(this.config.menusWidth),
					selected: false,
					letterStyle: {
						font: Absolute.ScreenMetrics.getResScale() * this.config.challengesMenuTabHeight / 2 + 'px Arial',
						fontFamily: 'segoe',
						fill: '#75bbe1',
						tint: 0x75bbe1,
						align: 'left'
					}
				}
			];

			if (this.tabsContainer) {
				this.container.removeChild(this.tabsContainer);
			}
			this.tabs = [];
			this.tabsContainer = new PIXI.DisplayObjectContainer();

			this.controlsGroupMap['Tabs'] = [];

			_.each(menuTabsData, function (menuTabData) {
				menuTabData.tabWidth = Absolute.Coords.x(menuTabData.tabWidth);
				menuTabData.tabPosition = Absolute.Coords.x(menuTabData.tabPosition);
				menuTabData.selectedCallback = this.tabSelected.bind(this);
				var tab = new MenuTab(menuTabData);
				if (menuTabData.selected) {
					this.selectedTab = tab;
				}
				this.tabs.push(tab);
				this.tabsContainer.addChildAt(tab, 0);
				this.controlsGroupMap['Tabs'].push(tab);
			}, this);

		};

		DailyChallengeMenu.prototype.setMenuContainerPosition = function () {
			this.menuContainer.x = this.game.ui.width / 2 - this.menuContainer.width / 2;
			this.menuContainer.y = this.game.menuBar.y + this.game.menuBar.menuButton.height + Absolute.Coords.y(this.config.pagePadding);
		};

		DailyChallengeMenu.prototype.tabSelected = function (selectedTab) {
			Absolute.AudioManager.playSound('button');
			this.selectedTab.onHide();
			if (this.progressMeter) {
				this.progressMeter.onHide();
			}
			this.selectedTab.updateState(false);
			this.tabsContainer.addChild(selectedTab);
			this.selectedTab = selectedTab;
			this.selectedTab.onShow();
		};

		DailyChallengeMenu.prototype.buildLobby = function (date) {

			this.challengeTiles = [];

			var todaysChallenges = SolitaireDailyChallengeService.CreateDailyChallenges(date);
			this.config.challengeTileTilesCount = todaysChallenges.length;

			this.controlFocusManager.removeControls('ChallengeTiles');
			this.controlsGroupMap['ChallengeTiles'] = [];

			// Challenge Tiles
			_.each(todaysChallenges, function (challenge) {
				var tileData = _.cloneDeep(this.getTileConfig(challenge.config.Data.GameMode));
				tileData.height = Absolute.Coords.y(this.config.challengeTileHeight);
				tileData.width = Absolute.Coords.x(this.config.challengeTileWidth);
				tileData.scaleText = (2.5 / 5) + (2.5 / this.config.challengeTileTilesPerRow);
				tileData.labelPosition.y = Absolute.Coords.y(tileData.labelPosition.y);
				tileData.isDailyChallenge = true;
				var challengeTile = new ChallengeTile(tileData, challenge, date, this);
				this.challengeTiles.push(challengeTile);
				this.controlsGroupMap['ChallengeTiles'].push(challengeTile);
			}, this);

			var config = _.cloneDeep(ScaleManager.scaleParams['MenuConfigs']['DCMenuConfigs']);
			config.tiles = this.challengeTiles;
			config.width = Absolute.Coords.x(this.config.menusWidth - this.config.menusShadowSize);

			config.tilePaddingX = Absolute.Coords.x(this.config.challengeTileSpacingBetween);
			config.tilePaddingY = Absolute.Coords.y(this.config.challengeTileSpacingBetween);

			this.lobbyMenu = new Menu(config);

			this.lobbyMenu.x = Absolute.Coords.x(this.config.challengesMenuPadding);
			this.lobbyMenu.y = Absolute.Coords.y(this.config.challengesMenuTabHeight + this.config.challengesMenuPadding);

			this.updateTheme();

			return this.lobbyMenu;
		};

		DailyChallengeMenu.prototype.buildCalendar = function () {

			this.calendar = new DailyChallengeCalendar(this);


			this.controlsGroupMap['Calendar'] = this.calendar.dateTiles;

			return this.calendar;
		};

		DailyChallengeMenu.prototype.showLobbyForDate = function (date) {
			this.date = date;
			this.tabs[0].setLabel(this.months[date.getMonth()] + ' ' + date.getDate());
			this.tabs[0].setContent(this.buildLobby(date));
			this.tabs[0].setSelected();
			this.controlFocusManager.removeAllControls();
			this.initControls();
		};


		DailyChallengeMenu.prototype.getTileConfig = function (mode) {
			return GameConfig.UI.dailyChallenges.lobby[mode];
		};

		DailyChallengeMenu.prototype.buildProgressMeter = function () {

			if (this.progressMeter) {
				this.container.removeChild(this.progressMeter);
			}
			var progressMeterConfig = {
				scale: this.config.progressMenuScale,
				height: this.config.progressMenuHeight, // Total Height
				// width: Absolute.Coords.x(1823),
				// height: Absolute.Coords.x(248),
				month: this.months[this.date.getMonth()]
			};

			this.progressMeter = new DailyChallengeProgressMeter(progressMeterConfig, this, this.ui);
			this.progressMeter.y = Absolute.Coords.y(
				this.tabsContainer.y +
				this.config.challengesMenuTabHeight +
				((this.config.challengesMenuHeight > this.config.calendarMenuHeight) ? // Chooses taller menu
					this.config.challengesMenuHeight : this.config.calendarMenuHeight) +
				this.config.pageMenuSpacing);
		};

		DailyChallengeMenu.prototype.onChallengeCompleted = function (challengeTile) {
			this.handleResize();
			this.progressMeter.updateProgress([challengeTile]);
		};

		DailyChallengeMenu.prototype.buildFUE = function () {

			var self = this,
				fue1 = new FUEDialog(this.ui, this.game,
					{
						dialog: 'DC-FUE-1',
						width: Absolute.Coords.x(1300),
						buttonText: _s('buttons.next'),
						closeHandler: function () {
							fue2.open();
						}.bind(this)
					}),
				fue2 = new FUEDialog(this.ui, this.game,
					{
						dialog: 'DC-FUE-2',
						width: Absolute.Coords.x(1400),
						height: Absolute.Coords.x(900),
						buttonY: 800,
						buttonText: _s('buttons.next'),
						contentInitialized: function () {

							if (Absolute.StringManager.getUserLanguage() === "fr-CA" || Absolute.StringManager.getUserLanguage() === "fr-FR") {
								this.setText('title', _s('dc_fue.fue2.headline', [self.months[self.date.getMonth()].toLowerCase()]));
								this.setText('bodyCopy', _s('dc_fue.fue2.description', [self.months[self.date.getMonth()].toLowerCase()]));
							}
							else {
								this.setText('title', _s('dc_fue.fue2.headline', [self.months[self.date.getMonth()]]));
								this.setText('bodyCopy', _s('dc_fue.fue2.description', [self.months[self.date.getMonth()]]));
							}

							var letterStyle = {
								font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 30 + "px Arial",
								fontFamily: 'segoe',
								fill: '#ebeabc',
								align: 'left'
							},
								bronzeInfo = self.progressMeter.getInfoBox(self.progressMeter.medalReferences.Bronze.coinsNeeded.toString(), true, letterStyle),
								silverInfo = self.progressMeter.getInfoBox(self.progressMeter.medalReferences.Silver.coinsNeeded.toString(), true, letterStyle),
								goldInfo = self.progressMeter.getInfoBox(self.progressMeter.medalReferences.Gold.coinsNeeded.toString(), true, letterStyle),
								diamondInfo = self.progressMeter.getInfoBox(self.progressMeter.medalReferences.Diamond.coinsNeeded.toString(), true, letterStyle);

							bronzeInfo.x = Absolute.Coords.x(30);
							silverInfo.x = Absolute.Coords.x(365);
							goldInfo.x = Absolute.Coords.x(695);
							diamondInfo.x = Absolute.Coords.x(1030);
							bronzeInfo.y = silverInfo.y = goldInfo.y = diamondInfo.y = Absolute.Coords.y(590);
							bronzeInfo.visible = silverInfo.visible = goldInfo.visible = diamondInfo.visible = true;
							this.contentContainer.addChild(bronzeInfo);
							this.contentContainer.addChild(silverInfo);
							this.contentContainer.addChild(goldInfo);
							this.contentContainer.addChild(diamondInfo);

						},
						closeHandler: function () {
							fue3.open();
						}.bind(this)
					}),
				fue3 = new FUEDialog(this.ui, this.game,
					{
						dialog: 'DC-FUE-3',
						width: Absolute.Coords.x(1300),
						closeHandler: function () {

						}.bind(this)
					});
			fue1.open();
		};

		DailyChallengeMenu.prototype.showLoadError = function () {

			this.ui.showWarning(_s("dialogs.manifestWarningHeadline"), _s("dialogs.manifestWarningContent"),
				function () {
					this.ui.hideLoadingScreen();
					this.game.navBack();
				}.bind(this)
			);
		};

		DailyChallengeMenu.prototype.handleCommand = function (command) {
			this.selectSection(command);
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Left': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Up': {
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Down': {
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}
		};

		DailyChallengeMenu.prototype.handlePageChange = function (from, to) {
			switch (to) {
				case 0:
					this.controlFocusManager.setFocusGroup('LeftButtons');
					break;
				case 1:
					this.controlFocusManager.setFocusGroup('RightButtons');
					break;
				case 2:
					this.controlFocusManager.setFocusGroup('Tabs');
					break;
				case 3:
					this.controlFocusManager.setFocusGroup('ChallengeTiles');
					break;
				case 4:
					this.controlFocusManager.setFocusGroup('ProgressMeter');
					break;
				case 5:
					this.controlFocusManager.setFocusGroup('BottomButtons');
					break;
			}
		};

		DailyChallengeMenu.prototype.selectSection = function (command) {
			var tabIndex = this.tabs.indexOf(this.selectedTab);
			if (command === 'Tab' || command === 'ShiftTab') {
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (this.page === 5) {
						this.handlePageChange(this.page, 0);
						this.page = 0;
					} else {
						if ((tabIndex === 0 && this.controlFocusManager.currentFocusGroup === 'Tabs')
							|| (tabIndex === 1 && this.controlFocusManager.currentFocusGroup === 'Calendar')
						) {
							this.controlFocusManager.nextFocusGroup();
						}
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (this.page === 0) {
						this.handlePageChange(this.page, 5);
						this.page = 5;
					} else {
						if ((tabIndex === 0 && this.controlFocusManager.currentFocusGroup === 'ChallengeTiles')
							|| (tabIndex === 1 && this.controlFocusManager.currentFocusGroup === 'ProgressMeter')
						) {
							this.controlFocusManager.prevFocusGroup();
						}
						this.controlFocusManager.prevFocusGroup();
					}
				}
				switch (this.controlFocusManager.currentFocusGroup) {
					case 'LeftButtons':
						this.page = 0;
						break;
					case 'RightButtons':
						this.page = 1;
						break;
					case 'Tabs':
						this.page = 2;
						break;
					case 'ChallengeTiles':
						this.page = 3;
						break;
					case 'ProgressMeter':
						this.page = 4;
						break;
					case 'BottomButtons':
						this.page = 5;
						break;
				}
			}
		};


		DailyChallengeMenu.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		DailyChallengeMenu.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
		};

		return DailyChallengeMenu;

	});

